import React, { useRef } from "react";

function VideoSection() {
  const videoRef1 = useRef(null);
  const videoRef2 = useRef(null);

  const handleMouseEnter = (videoRef) => {
    videoRef.current.play();
  };

  const handleMouseLeave = (videoRef) => {
    videoRef.current.pause();
    videoRef.current.currentTime = 0;
  };

  return (
    <div className="web-sect home-video-sec pad-60">
      <div className="video-bg">
        <div className="container">
          <div className="video-container">
            <div className="video-wrapper-in">
                <figure className="video-wrap">
                <video
                    ref={videoRef1}
                    className="video"
                    preload="metadata"
                    crossOrigin="anonymous"
                    loop
                    playsInline
                    muted
                    controls
                    poster={require("../../img/Layer 1.png")}
                    onMouseEnter={() => handleMouseEnter(videoRef1)}
                    onMouseLeave={() => handleMouseLeave(videoRef1)}
                >
                    <source
                    src={require("../../img/varachha.mp4")}
                    type="video/mp4"
                    />
                </video>              
                </figure>
                <div className="video-caption">Head Branch</div>
            </div>
            <div className="video-wrapper-in">
                <figure className="video-wrap">
                <video
                    ref={videoRef2}
                    className="video"
                    preload="metadata"
                    crossOrigin="anonymous"
                    loop
                    playsInline
                    muted
                    controls
                    poster={require("../../img/Layer 1.png")}
                    onMouseEnter={() => handleMouseEnter(videoRef2)}
                    onMouseLeave={() => handleMouseLeave(videoRef2)}
                >
                    <source src={require("../../img/pal.mov")} type="video/mp4" />
                </video>              
                </figure>
                <div className="video-caption">Pal Branch</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VideoSection;
